import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Models
import mPriceGrid from 'models/cpm/priceGrid';
// Custom
import { openDialog } from 'actions';
import { cpmPriceGridDataShape } from 'constants/PropTypesShapes';
import { InfoIconButton } from 'components/buttons/IconButtons';

class PriceGridInfoButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleShowPriceGrid = this.handleShowPriceGrid.bind(this);
  }

  // Handlers called by parent (= DialogItem)
  handleShowPriceGrid() {
    const { priceGrid, handleOpenDialog } = this.props;
    handleOpenDialog({
      title: {
        fixed: mPriceGrid.title(priceGrid),
      },
      actions: [
        { type: 'close' },
      ],
      component: {
        type: 'CARPARK_PRICE_GRID_INFO',
        props: {
          priceGrid,
        },
      },
      dividers: true,
      size: 'sm',
    });
  }

  render() {
    const { priceGrid } = this.props;

    if (priceGrid) {
      return (
        <InfoIconButton
          primary
          tooltipId="tooltip.priceGridDetails"
          size="small"
          onClick={this.handleShowPriceGrid}
        />
      );
    }
    return null;
  }
}

PriceGridInfoButton.propTypes = {
  priceGridId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  priceGrid: cpmPriceGridDataShape,
  handleOpenDialog: PropTypes.func.isRequired,
};

PriceGridInfoButton.defaultProps = {
  priceGridId: null,
  priceGrid: null,
};

const mapStateToProps = (state, ownProps) => ({
  priceGrid: _find(state.cpmCarparkPriceGrid.list.elements, ['id', ownProps.priceGridId]),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceGridInfoButton);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/priceGrids/PriceGridInfoButton.js